module.exports = __webpack_public_path__ + "img/pysc1.52eb003f.png";